<template>
    <div class="editsuperSpecialNews">
        <el-breadcrumb class="bread-nav" separator="/">
            <el-breadcrumb-item>首页</el-breadcrumb-item>
            <el-breadcrumb-item>市场专题</el-breadcrumb-item>
            <el-breadcrumb-item>编辑新闻</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="edit-superSpecial-news-box">
            <div class="superSpecial-list-box">
                <el-input placeholder="输入关键字进行过滤" v-model="filterText">
                </el-input>
                <el-tree ref="specialList" :filter-node-method="filterNode" :data="specialList" :props="propsRules" @node-click="selectSpecial" :highlight-current="true"></el-tree>
            </div>
            <div v-if="specialId" class="add-news-container">
                <el-card class="select-module">
                    <div slot="header">
                        <p class="title">项目和模板</p>
                    </div>
                    <div class="superSpecial-select">
                        <span>选择模块</span>
                        <el-select v-model="moduleId" @change="addNewsSelectModule" placeholder="请选择">
                            <el-option :key="-1" label="默认模块" :value="null">
                            </el-option>
                            <el-option v-for="item in moduleList" :key="item.moduleId" :label="item.moduleName" :value="item.moduleId">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="superSpecial-select">
                        <span>选择组件</span>
                        <el-select v-model="selectedTemplate" @change="addNewsSelectTemplate" placeholder="请选择">
                            <el-option v-for="item in newsTypeList" :key="item.newsTypeId" :label="item.newsTypeName" :value="item">
                            </el-option>
                        </el-select>
                    </div>
                </el-card>

                <el-card v-show="newsTypeId" class="add-news">
                    <div slot="header">
                        <p class="title">新闻内容</p>
                    </div>
                    <!--大图新闻-->
                    <yd-big-img-form v-if="newsTypeName==='大图新闻'" :newsData="addNewsForm" :addForm="true" @newsFormSubmit="newsFormSubmit"></yd-big-img-form>
                    <!--end-->
                    <!--视频新闻-->
                    <yd-video-news-form v-if="newsTypeName==='视频新闻'" :newsData="addNewsForm" :addForm="true" @newsFormSubmit="newsFormSubmit"></yd-video-news-form>
                    <!--end-->
                    <!--多图新闻-->
                    <yd-three-img-form v-if="newsTypeName==='多图新闻'" :newsData="addNewsForm" :addForm="true" :threeImages="duotuImages" @newsFormSubmit="newsFormSubmit" @newsFormReset="newsFormReset"></yd-three-img-form>
                    <!--end-->
                    <!--单图新闻-->
                    <yd-one-img-form v-if="newsTypeName==='单图新闻'" :newsData="addNewsForm" :addForm="true" @newsFormSubmit="newsFormSubmit"></yd-one-img-form>
                    <!--end-->
                    <!--无图新闻-->
                    <yd-none-img-form v-if="newsTypeName==='无图新闻'" :newsData="addNewsForm" :addForm="true" @newsFormSubmit="newsFormSubmit"></yd-none-img-form>
                    <!--end-->
                    <!--轮播图-->
                    <yd-slides-news-form v-if="newsTypeName==='轮播图'" :newsData="addNewsForm" :lunboImages="lunboImages" :lunboSlideNum="lunboSlideNum" :lunboURLs="lunboURLs" :lunboInfos="lunboInfos" :addForm="true" @newsFormSubmit="newsFormSubmit" @newsFormReset="newsFormReset" @addSlide="addSlide" @delSlide="delSlide"></yd-slides-news-form>
                    <!--end-->
                    <!--轮播图（竖）-->
                    <yd-slides-news-vertical-form v-if="newsTypeName==='轮播图（竖）'" :newsData="addNewsForm" :lunboImages="lunboImages" :lunboSlideNum="lunboSlideNum" :lunboURLs="lunboURLs" :lunboInfos="lunboInfos" :addForm="true" @newsFormSubmit="newsFormSubmit" @newsFormReset="newsFormReset" @addSlide="addSlide" @delSlide="delSlide"></yd-slides-news-vertical-form>
                    <!--end-->
                    <!--视频直播-->
                    <yd-live-news-form v-if="newsTypeName==='视频直播'" :newsData="addNewsForm" :addForm="true" @newsFormSubmit="newsFormSubmit"></yd-live-news-form>
                    <!--end-->
                    <!--线索收集-->
                    <yd-collect-news-form v-if="newsTypeName==='线索收集'" :newsData="addNewsForm" :projectList="projectList" :addForm="true" @newsFormSubmit="newsFormSubmit"></yd-collect-news-form>
                    <!--end-->
                    <!-- 按钮 -->
                    <YdButtonForm v-if="newsTypeName==='按钮'" :newsData="addNewsForm" :addForm="true" @newsFormSubmit="newsFormSubmit"></YdButtonForm>
                    <!-- end -->
                </el-card>
                <el-card v-if="newsTypeId" class="news-preview">
                    <div slot="header">
                        <p class="title">新闻预览</p>
                    </div>
                    <!--大图新闻-->
                    <yd-big-img :newsData="addNewsForm" v-if="newsTypeName==='大图新闻'"></yd-big-img>
                    <!--end-->
                    <!--单图新闻-->
                    <yd-one-img :newsData="addNewsForm" v-if="newsTypeName==='单图新闻'"></yd-one-img>
                    <!--end-->
                    <!--轮播图-->
                    <yd-slides-news :newsData="addNewsForm" :lunboSlideNum="lunboSlideNum" :lunboImages="lunboImages" v-if="newsTypeName==='轮播图'"></yd-slides-news>
                    <!--end-->
                    <!--轮播图（竖）-->
                    <yd-slides-news-vertical :newsData="addNewsForm" :lunboSlideNum="lunboSlideNum" :lunboImages="lunboImages" v-if="newsTypeName==='轮播图（竖）'"></yd-slides-news-vertical>
                    <!--end-->
                    <!--多图新闻-->
                    <yd-three-img :newsData="addNewsForm" :threeImages="duotuImages" v-if="newsTypeName==='多图新闻'"></yd-three-img>
                    <!--end-->
                    <!--视频直播-->
                    <yd-live-news :newsData="addNewsForm" v-if="newsTypeName==='视频直播'"></yd-live-news>
                    <!--end-->
                    <!--视频新闻-->
                    <yd-video-news :newsData="addNewsForm" v-if="newsTypeName==='视频新闻'"></yd-video-news>
                    <!--end-->
                    <!--无图新闻-->
                    <yd-none-img :newsData="addNewsForm" v-if="newsTypeName==='无图新闻'"></yd-none-img>
                    <!--end-->
                    <!--线索收集-->
                    <yd-collect-news :newsData="addNewsForm" v-if="newsTypeName==='线索收集'"></yd-collect-news>
                    <!--end-->
                    <YdButton :newsData="addNewsForm" v-if="newsTypeName==='按钮'"></YdButton>
                </el-card>
            </div>
            <div class="news-list-box" v-if="newsList">
                <div class="header-image">
                    <img :src="newsList.focusImgUrl" alt="图片地址错误">
                </div>
                <div class="description" v-if="newsList.specialContent">
                    <div class="desc-icon">概述</div>
                    <span class="desc-content">{{newsList.specialContent}}</span>
                </div>
                <div v-for="_module in newsList.modules" class="component-module">
                    <div v-if="_module.moduleIdNew!=-1" class="module-header">
                        <img v-if="_module.bgImage" :src="_module.bgImage" alt="图片地址错误">
                        <p :class="[_module.bgImage?'':'title2','title']">{{_module.moduleName}}</p>
                        <!--<p class="module-content">{{_module.moduleContent}}</p>-->
                    </div>
                    <ul class="news-list">
                        <li v-for="news in _module.moduleNewsList">
                            <!--多图新闻-->
                            <yd-three-img :newsData="news" @newsClick="newsItemClick" :threeImages="news.newsContentImage.split(';')" v-if="news.newsTypeName==='多图新闻'"></yd-three-img>
                            <!--end-->
                            <!--线索收集-->
                            <yd-collect-news :newsData="news" @newsClick="newsItemClick" v-if="news.newsTypeName==='线索收集'"></yd-collect-news>
                            <!--end-->
                            <!--单图新闻-->
                            <yd-one-img :newsData="news" @newsClick="newsItemClick" v-if="news.newsTypeName==='单图新闻'"></yd-one-img>
                            <!--end-->
                            <!--大图新闻-->
                            <yd-big-img :newsData="news" @newsClick="newsItemClick" v-if="news.newsTypeName==='大图新闻'"></yd-big-img>
                            <!--end-->
                            <!--轮播图-->
                            <yd-slides-news :newsData="news" @newsClick="newsItemClick" :lunboSlideNum="news.newsContentImage.split(';').length" :lunboImages="news.newsContentImage.split(';')" v-if="news.newsTypeName==='轮播图'"></yd-slides-news>
                            <!--end-->
                            <!--轮播图（竖）-->
                            <yd-slides-news-vertical :newsData="news" @newsClick="newsItemClick" :lunboSlideNum="news.newsContentImage.split(';').length" :lunboImages="news.newsContentImage.split(';')" v-if="news.newsTypeName==='轮播图（竖）'"></yd-slides-news-vertical>
                            <!--end-->
                            <!--视频直播-->
                            <yd-live-news :newsData="news" @newsClick="newsItemClick" v-if="news.newsTypeName==='视频直播'"></yd-live-news>
                            <!--end-->
                            <!--视频新闻-->
                            <yd-video-news :newsData="news" @newsClick="newsItemClick" v-if="news.newsTypeName==='视频新闻'"></yd-video-news>
                            <!--end-->
                            <!--无图新闻-->
                            <yd-none-img :newsData="news" @newsClick="newsItemClick" v-if="news.newsTypeName==='无图新闻'"></yd-none-img>
                            <!--end-->
                            <!-- 按钮 -->
                            <YdButton :newsData="news" @newsClick="newsItemClick" v-if="news.newsTypeName==='按钮'"></YdButton>
                            <!-- end -->
                            <el-button-group class="btn-group" v-if="news.newsTypeName">
                                <el-button @click="delNews(news.newsContentId)" size="mini" type="danger">删除</el-button>
                                <el-button @click="editNews(news)" size="mini" type="warning">编辑</el-button>
                            </el-button-group>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <!--编辑弹框-->
        <el-dialog title="编辑-新闻"  v-model="dialogFormVisible" :modal-append-to-body="false" :close-on-click-modal="false">
            <el-card class="edit-news-preview-box" style="margin-bottom: 20px;">
                <div style="width:400px;margin:0 auto;">
                    <!--多图新闻-->
                    <yd-three-img :newsData="editNewsForm" :threeImages="editNewsForm.newsContentImage.split(';')" v-if="editNewsForm.newsTypeName==='多图新闻'"></yd-three-img>
                    <!--end-->
                    <!--线索收集-->
                    <yd-collect-news :newsData="editNewsForm" v-if="editNewsForm.newsTypeName==='线索收集'"></yd-collect-news>
                    <!--end-->
                    <!--单图新闻-->
                    <yd-one-img :newsData="editNewsForm" v-if="editNewsForm.newsTypeName==='单图新闻'"></yd-one-img>
                    <!--end-->
                    <!--大图新闻-->
                    <yd-big-img :newsData="editNewsForm" v-if="editNewsForm.newsTypeName==='大图新闻'"></yd-big-img>
                    <!--end-->
                    <!--轮播图-->
                    <yd-slides-news :newsData="editNewsForm" :lunboSlideNum="lunboSlideNum2" :lunboImages="lunboImages2" v-if="editNewsForm.newsTypeName==='轮播图'"></yd-slides-news>
                    <!--end-->
                    <!--轮播图（竖）-->
                    <yd-slides-news-vertical :newsData="editNewsForm" :lunboSlideNum="lunboSlideNum2" :lunboImages="lunboImages2" v-if="editNewsForm.newsTypeName==='轮播图（竖）'"></yd-slides-news-vertical>
                    <!--end-->
                    <!--视频直播-->
                    <yd-live-news :newsData="editNewsForm" v-if="editNewsForm.newsTypeName==='视频直播'"></yd-live-news>
                    <!--end-->
                    <!--视频新闻-->
                    <yd-video-news :newsData="editNewsForm" v-if="editNewsForm.newsTypeName==='视频新闻'"></yd-video-news>
                    <!--end-->
                    <!--无图新闻-->
                    <yd-none-img :newsData="editNewsForm" v-if="editNewsForm.newsTypeName==='无图新闻'"></yd-none-img>
                    <!--end-->
                    <!-- 按钮 -->
                    <YdButton :newsData="editNewsForm" v-if="editNewsForm.newsTypeName==='按钮'"></YdButton>
                    <!-- end -->
                </div>
            </el-card>
            <el-card>
                <!--大图新闻-->
                <yd-big-img-form v-if="editNewsForm.newsTypeName==='大图新闻'" :isEdit="true" :newsData="editNewsForm" :addForm="false" @newsFormSubmit="newsFormSubmit" @newsFormCancle="newsFormCancle"></yd-big-img-form>
                <!--end-->
                <!--视频新闻-->
                <yd-video-news-form v-if="editNewsForm.newsTypeName==='视频新闻'" :isEdit="true" :newsData="editNewsForm" :addForm="false" @newsFormSubmit="newsFormSubmit" @newsFormCancle="newsFormCancle"></yd-video-news-form>
                <!--end-->
                <!--多图新闻-->
                <yd-three-img-form v-if="editNewsForm.newsTypeName==='多图新闻'" :isEdit="true" :newsData="editNewsForm" :addForm="false" :threeImages="duotuImages2" @newsFormSubmit="newsFormSubmit" @newsFormReset="newsFormReset" @newsFormCancle="newsFormCancle"></yd-three-img-form>
                <!--end-->
                <!--单图新闻-->
                <yd-one-img-form v-if="editNewsForm.newsTypeName==='单图新闻'" :isEdit="true" :newsData="editNewsForm" :addForm="false" @newsFormSubmit="newsFormSubmit" @newsFormCancle="newsFormCancle"></yd-one-img-form>
                <!--end-->
                <!--无图新闻-->
                <yd-none-img-form v-if="editNewsForm.newsTypeName==='无图新闻'" :isEdit="true" :newsData="editNewsForm" :addForm="false" @newsFormSubmit="newsFormSubmit" @newsFormCancle="newsFormCancle"></yd-none-img-form>
                <!--end-->
                <!--轮播图-->
                <yd-slides-news-form v-if="editNewsForm.newsTypeName==='轮播图'" :isEdit="true" :newsData="editNewsForm" :lunboImages="lunboImages2" :lunboSlideNum="lunboSlideNum2" :lunboURLs="lunboURLs2" :lunboInfos="lunboInfos2" :addForm="false" @newsFormSubmit="newsFormSubmit" @newsFormReset="newsFormReset" @addSlide="addSlide2" @delSlide="delSlide2" @newsFormCancle="newsFormCancle"></yd-slides-news-form>
                <!--end-->
                <!--轮播图（竖）-->
                <yd-slides-news-vertical-form v-if="editNewsForm.newsTypeName==='轮播图（竖）'" :isEdit="true" :newsData="editNewsForm" :lunboImages="lunboImages2" :lunboSlideNum="lunboSlideNum2" :lunboURLs="lunboURLs2" :lunboInfos="lunboInfos2" :addForm="false" @newsFormSubmit="newsFormSubmit" @newsFormReset="newsFormReset" @addSlide="addSlide2" @delSlide="delSlide2" @newsFormCancle="newsFormCancle"></yd-slides-news-vertical-form>
                <!--end-->
                <!--视频直播-->
                <yd-live-news-form v-if="editNewsForm.newsTypeName==='视频直播'" :isEdit="true" :newsData="editNewsForm" :addForm="false" @newsFormSubmit="newsFormSubmit" @newsFormCancle="newsFormCancle"></yd-live-news-form>
                <!--end-->
                <!--线索收集-->
                <yd-collect-news-form v-if="editNewsForm.newsTypeName==='线索收集'" :isEdit="true" :newsData="editNewsForm" :projectList="projectList" :addForm="false" @newsFormSubmit="newsFormSubmit" @newsFormCancle="newsFormCancle"></yd-collect-news-form>
                <!--end-->
                <!-- 按钮 -->
                <YdButtonForm v-if="editNewsForm.newsTypeName==='按钮'" :isEdit="true" :newsData="editNewsForm" @newsFormSubmit="newsFormSubmit" @newsFormCancle="newsFormCancle"></YdButtonForm>
                <!-- end -->
            </el-card>
        </el-dialog>
        <!--end-->
    </div>
</template>
<script>
import BigImgComponent from './common/newsTemplate/BigImg';
import VideoNewsComponent from './common/newsTemplate/VideoNews';
import ThreeImgComponent from './common/newsTemplate/ThreeImg';
import OneImgComponent from './common/newsTemplate/OneImg';
import NoneImgComponent from './common/newsTemplate/NoneImg';
import LiveNewsComponent from './common/newsTemplate/LiveNews';
import CollectNewsComponent from './common/newsTemplate/CollectNews';
import SlidesNewsComponent from './common/newsTemplate/SlidesNews';
import SlideNewsVerticalComponent from './common/newsTemplate/SlidesNewsVertical';
import ButtonComponent from './common/newsTemplate/Button';

import BigImgForm from './common/newsAddForm/BigImg';
import VideoNewsForm from './common/newsAddForm/VideoNews';
import ThreeImgForm from './common/newsAddForm/ThreeImg';
import OneImgForm from './common/newsAddForm/OneImg';
import NoneImgForm from './common/newsAddForm/NoneImg';
import SlidesNewsForm from './common/newsAddForm/SlidesNews';
import LiveNewsForm from './common/newsAddForm/LiveNews';
import CollectNewsForm from './common/newsAddForm/CollectNews';
import SlidesNewsVerticalForm from './common/newsAddForm/SlidesNewsVertical';
import ButtonForm from './common/newsAddForm/Button';

import CONFIG from "@/config/index.js";
import TOOL from '@/tool/index.js';
import router from "@/router/index.js";
import { mapGetters } from 'vuex';
export default {
    name: "editSpecialNews",
    data() {
        return {
            filterText: '', //专题搜索
            specialList: null, //专题列表
            newsList: null, //新闻列表
            newsTypeList: null, //新闻类型列表
            moduleList: null, //模块列表
            projectList: null, //项目列表
            specialId: '', //专题编号
            moduleId: '', //模块编号
            newsTypeId: '', //新闻类型编号
            newsTypeName: '', //新闻类型名称
            selectedTemplate: null, //已选择的新闻类型
            duotuImages: ["", "", ""], //【添加】多图图片列表
            lunboImages: [], //【添加】轮播图片列表
            lunboURLs: [], //【添加】轮播图落地页列表
            lunboInfos: [], //【添加】轮播图描述列表
            lunboSlideNum: 1, //【添加】轮播slide数量
            duotuImages2: ["", "", ""], //【编辑】多图图片列表
            lunboImages2: [], //【编辑】轮播图片列表
            lunboURLs2: [], //【编辑】轮播图落地页列表
            lunboInfos2: [], //【编辑】轮播图描述列表
            lunboSlideNum2: 1, //【编辑】轮播slide数量
            dialogFormVisible: false, //编辑dialog的可见性
            addNewsForm: {
                newsContentTitle: '',
                newsContentSource: '',
                newsContentURL: '',
                newsContentCreateUser: '',
                newsContentUpdateUser: '',
                newsTypeId: '',
                specialId: '',
                newsContentImage: '',
                newsInfo: '',
                moduleId: ''
            },
            editNewsForm: {},
            propsRules: {
                children: null,
                label: "specialName"
            }
        };
    },
    components: {
        YdBigImg: BigImgComponent,
        YdVideoNews: VideoNewsComponent,
        YdThreeImg: ThreeImgComponent,
        YdOneImg: OneImgComponent,
        YdNoneImg: NoneImgComponent,
        YdLiveNews: LiveNewsComponent,
        YdCollectNews: CollectNewsComponent,
        YdSlidesNews: SlidesNewsComponent,
        YdButton: ButtonComponent,
        YdBigImgForm: BigImgForm,
        YdVideoNewsForm: VideoNewsForm,
        YdThreeImgForm: ThreeImgForm,
        YdOneImgForm: OneImgForm,
        YdNoneImgForm: NoneImgForm,
        YdSlidesNewsForm: SlidesNewsForm,
        YdLiveNewsForm: LiveNewsForm,
        YdCollectNewsForm: CollectNewsForm,
        YdSlidesNewsVertical: SlideNewsVerticalComponent,
        YdSlidesNewsVerticalForm: SlidesNewsVerticalForm,
        YdButtonForm: ButtonForm
    },
    computed: {
        ...mapGetters({
            userInfo: 'getUserInfo'
        })
    },
    mounted() {
        this._init();
    },
    watch: {
        filterText(val) {
            this.$refs.specialList.filter(val);
        }
    },
    methods: {
        filterNode(value, data) {
            if (!value) return true;
            return data.specialName.indexOf(value) !== -1;
        },
        _getSpecialList() {
            this.$http.get(CONFIG.HOST + "/superSpecial/list" + '?t=' + TOOL.getCurrentTime()).then((response) => {
                let result = response.body;
                if (result && result.status === 1) {
                    this.specialList = result.data;
                } else {
                    this.$notify.error({
                        message: result.message
                    });
                }
            }, (response) => {
                console.log(response);
            });
        },
        _getModuleList() {
            if (this.specialId <= 0) {
                this.$notify.error({
                    message: '【营销平台】specialId=' + this.specialId + '的专题不存在'
                });
                return;
            }
            this.$http.get(CONFIG.HOST + "/superSpecialModule/list/" + this.specialId + '?t=' + TOOL.getCurrentTime()).then((response) => {
                let result = response.body;
                if (result && result.status === 1) {
                    this.moduleList = result.data;
                } else {
                    this.$notify.error({
                        message: result.message
                    });
                }
            }, (response) => {
                console.log(response);
            });
        },
        _getProjectList() {
            this.$http.get(CONFIG.HOST + '/yysj/list?t=' + TOOL.getCurrentTime()).then((response) => {
                let result = response.body;
                if (result && result.status === 1) {
                    this.projectList = result.data;
                } else {
                    this.$notify.error({
                        message: result.message
                    });
                }
            }, (response) => {
                console.log(response);
            });
        },
        _getNewsTypeList() {
            this.$http.get(CONFIG.HOST + '/mkTemplate/list?t=' + TOOL.getCurrentTime()).then((response) => {
                let result = response.body;
                if (result && result.status === 1) {
                    this.newsTypeList = result.data;
                } else {
                    this.$notify.error({
                        message: result.message
                    });
                }
            }, (response) => {
                console.log(response);
            });
        },
        _getNews(specialId = -1) {
            if (specialId <= 0) {
                this.$notify.error({
                    message: '【营销平台】specialId=' + specialId + '的专题不存在'
                });
                return;
            }
            this.$http.post(CONFIG.HOST + "/superSpecial/check" + "?t=" + TOOL.getCurrentTime(), { specialId: specialId }).then((response) => {
                let result = response.body;
                if (result && result.status === 1) {
                    this.newsListClearUp(result.data);
                } else {
                    this.$notify.error({
                        message: result.message
                    });
                }
            }, (response) => {
                console.log(response);
            });
        },
        _confirmMessage(message, success = () => { }, cancel = () => { }) {
            this.$confirm(message, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(success).catch(cancel);
        },
        _init() {
            this._getSpecialList();
            this._getNewsTypeList();
            this._getProjectList();
        },
        selectSpecial(data) {
            this.newsList = null;
            this.moduleId = '';
            this.specialId = data.specialId;
            this._getNews(this.specialId);
            // let news = {};
            // this.newsListClearUp(news);
            this._getModuleList();
        },
        //添加新闻时选择的模板
        addNewsSelectTemplate(template) {
            this.newsTypeId = template.newsTypeId;
            this.newsTypeName = template.newsTypeName;
            // this.$refs.addNewsForm.resetFields();
            this.resetAddNews();
            this.addNewsForm.newsTypeId = template.newsTypeId;
        },
        //添加新闻时选择的模块
        addNewsSelectModule(moduleId) {
            console.log("moduleId:", this.moduleId);
        },
        //【添加】添加轮播slide
        addSlide() {
            this.lunboImages.push("");
            this.lunboURLs.push("");
            this.lunboInfos.push("");
            ++this.lunboSlideNum;
        },
        //【添加】删除轮播slide
        delSlide() {
            if (this.lunboSlideNum < 2) {
                return;
            }
            this.lunboImages = this.lunboImages.slice(0, this.lunboSlideNum - 1);
            this.lunboURLs = this.lunboURLs.slice(0, this.lunboSlideNum - 1);
            this.lunboInfos = this.lunboInfos.slice(0, this.lunboSlideNum - 1);
            --this.lunboSlideNum;
        },
        //【编辑】添加轮播slide
        addSlide2() {
            this.lunboImages2.push("");
            this.lunboURLs2.push("");
            this.lunboInfos2.push("");
            ++this.lunboSlideNum2;
        },
        //【编辑】删除轮播slide
        delSlide2() {
            if (this.lunboSlideNum2 < 2) {
                return;
            }
            this.lunboImages2 = this.lunboImages2.slice(0, this.lunboSlideNum2 - 1);
            this.lunboURLs2 = this.lunboURLs2.slice(0, this.lunboSlideNum2 - 1);
            this.lunboInfos2 = this.lunboInfos.slice(0, this.lunboSlideNum2 - 1);
            --this.lunboSlideNum2;
        },
        //重置
        resetAddNews() {
            // this.$refs.addNewsForm.resetFields();
            this.addNewsForm.newsContentTitle = "";
            this.addNewsForm.newsContentSource = "";
            this.addNewsForm.newsContentURL = "";
            this.addNewsForm.newsContentImage = "";
            this.addNewsForm.newsInfo = "";
            this.duotuImages = ["", "", ""];
            this.lunboImages = [""];
            this.lunboURLs = [""];
            this.lunboInfos = [""];
            this.lunboSlideNum = 1;
        },
        //整理新闻列表
        newsListClearUp(news) {
            this.newsList = null;
            let newsListNew = null;
            newsListNew = news.special;
            newsListNew.modules = [];
            news.modules.forEach((module, index, array) => {
                newsListNew.modules[index] = module;
                newsListNew.modules[index].moduleNewsList = [];
                for (let mnews of news.news) {
                    if (mnews.moduleIdNew === module.moduleIdNew) {
                        newsListNew.modules[index].moduleNewsList.push(mnews);
                    }
                }
            });
            this.newsList = newsListNew;
        },
        //删除新闻
        delNews(newsContentId) {
            this._confirmMessage('是否确定删除该新闻？', () => {
                if (newsContentId < 0) {
                    this.$notify.error({
                        message: '【营销平台】newsContentId=' + newsContentId + '的新闻不存在'
                    });
                    return;
                }
                this.$http.delete(CONFIG.HOST + '/superSpecial/deleteNews/' + newsContentId).then((response) => {
                    let result = response.body;
                    if (result && result.status === 1) {
                        this.$notify.success({
                            message: '删除新闻成功'
                        });
                        this._getNews(this.specialId);
                    } else {
                        this.$notify.error({
                            message: result.message
                        });
                    }
                }, (response) => {
                    console.log(response);
                });
            });
        },
        //编辑新闻
        editNews(news) {
            this.editNewsForm = {};
            this.duotuImages2 = ["", "", ""];
            this.lunboImages2 = [""];
            this.lunboURLs2 = [""];
            this.lunboInfos2 = [""];
            this.editNewsForm = Object.assign({}, news);
            if (news.newsTypeName === "多图新闻") {
                this.duotuImages2 = news.newsContentImage.split(";");
            }
            if (news.newsTypeName === "轮播图") {
                this.lunboImages2 = news.newsContentImage.split(";");
                this.lunboURLs2 = news.newsContentURL.split(";");
                this.lunboInfos2 = news.newsInfo.split(";");
                this.lunboSlideNum2 = this.lunboImages2.length;
            }
            this.dialogFormVisible = true;
        },
        //点击新闻跳转
        newsItemClick(newsUrl) {
            window.open(newsUrl);
        },
        //添加或编辑新闻提交
        newsFormSubmit(data, addForm) {
            if (this.userInfo.userId <= 0) {
                this.$notify.error({
                    message: '【营销平台】用户不存在'
                });
                return;
            }
            if (addForm) {
                if (this.specialId <= 0) {
                    this.$notify.error({
                        message: '【营销平台】specialId=' + this.specialId + '的专题不存在'
                    });
                    return;
                }
                console.log(this.moduleId);
                if (!(this.moduleId===null||(typeof this.moduleId === "number"&&this.moduleId>0))) {//this.moduleId <= 0
                    this.$notify.error({
                        message: '【营销平台】请选择模块'
                    });
                    return;
                }
                if (this.newsTypeName === "轮播图") {
                    this.addNewsForm.newsContentImage = this.lunboImages.join(";");
                    this.addNewsForm.newsContentURL = this.lunboURLs.join(";");
                    this.addNewsForm.newsInfo = this.lunboInfos.join(";");
                }
                this.addNewsForm.newsContentCreateUser = this.addNewsForm.newsContentUpdateUser = this.userInfo.userId;
                this.addNewsForm.specialId = this.specialId;
                this.addNewsForm.moduleId = this.moduleId;
                this.$http.post(CONFIG.HOST + '/superSpecial/addNews', this.addNewsForm).then((response) => {
                    let result = response.body;
                    if (result && result.status === 1) {
                        this.$notify.success({
                            message: '【营销平台】市场专题添加新闻成功'
                        });
                        this.resetAddNews();
                        this._getNews(this.specialId);
                    } else {
                        this.$notify.error({
                            message: result.message
                        });
                    }
                }, (response) => {
                    console.log(response);
                });
            } else {
                if (this.editNewsForm.newsTypeName.indexOf('轮播图') !== -1) {
                    this.editNewsForm.newsContentImage = this.lunboImages2.join(";");
                    this.editNewsForm.newsContentURL = this.lunboURLs2.join(";");
                    this.editNewsForm.newsInfo = this.lunboInfos2.join(";");
                }
                if (this.editNewsForm.newsTypeName.indexOf('按钮') !== -1) {
                    this.editNewsForm.newsContentSource = "一点资讯";
                }
                this.editNewsForm.newsContentUpdateUser = this.userInfo.userId;
                this.$http.put(CONFIG.HOST + '/superSpecial/updateNews', this.editNewsForm).then((response) => {
                    let result = response.body;
                    if (result && result.status === 1) {
                        this.$notify.success({
                            message: '编辑新闻成功'
                        });
                        this._getNews(this.specialId);
                        this.dialogFormVisible = false;
                    } else {
                        this.$notify.error({
                            message: result.message
                        });
                    }
                }, (response) => {
                    console.log(response);
                });
            }
        },
        //dialog取消
        newsFormCancle() {
            this.dialogFormVisible = false;
        },
        //重置表单
        newsFormReset() {
            this.duotuImages = ["", "", ""];
            this.lunboImages = [""];
            this.lunboURLs = [""];
            this.lunboInfos = [""];
            this.lunboSlideNum = 1;
        }
    }
};
</script>
<style lang="less">
.editsuperSpecialNews {
    width: 98%;
    margin: 0 auto;
    .bread-nav {
        margin: 20px 0;
    }
    .edit-superSpecial-news-box {
        width: 100%;
        position: relative;
        .superSpecial-list-box {
            width: 270px;
            .el-input {
                margin-bottom: 10px;
            }
            .el-tree-node {
                border: 1px solid #E5E9F2;
                color: #20A0FF;
            }
            .is-current {
                >.el-tree-node__content {
                    background-color: #58B7FF;
                    color: white;
                }
            }
            .el-tree-node__expand-icon {
                border: 0;
                margin: 0
            }
        }
        .add-news-container {
            width: 380px;
            height: 100%;
            position: absolute;
            top: 0;
            left: 630px;
            .select-module {
                text-align: left;
                font-size: 14px;
                .superSpecial-select {
                    margin-left: 40px;
                    margin-bottom: 10px;
                    >span {
                        font-weight: bold;
                    }
                    .el-select {
                        margin-left: 10px;
                    }
                }
            }
            .add-news {
                margin-top: 20px;
                text-align: left;
                font-size: 14px;
            }
        }
        .news-preview {
            margin-top: 20px;
            box-sizing: border-box;
            width: 100%;
            text-align: left;
            padding: 5px;
            margin-bottom: 20px;
            .el-card__body {
                padding: 0;
                margin-top: 10px;
            }
            .title {
                font-size: 14px;
            }
        }
        .news-list-box {
            width: 320px;
            height: 560px;
            overflow: auto;

            position: absolute;
            top: 0;
            left: 290px;
            border: 1px solid #bfcbd9;
            .header-image {
                width: 100%;
                display: block;
                img {
                    width: 100%;
                }
            }
            .description {
                padding: 11px;
                font-size: 10px;
                text-align: left;
                border-bottom: 1px solid #D3DCE6;
                .desc-icon {
                    color: #fff;
                    background: #0c9aee;
                    display: inline-flex;
                    padding-left: 2px;
                    padding-right: 2px;
                }
            }
            .component-module {
                margin-bottom: 20px;
                .module-header {
                    position: relative;
                    min-height: 32px;
                    >img {
                        display: block;
                        width: 100%;
                        height: auto
                    }
                    .title {
                        position: absolute;
                        top: 10px;
                        left: 10px;
                        font-size: 12px;
                        color: white;
                        font-weight: bold;
                    }
                    .title2 {
                        box-sizing: border-box;
                        top: 0;
                        left: 0;
                        width: 100%;
                        height: 100%;
                        line-height: 32px;
                        padding-left: 10px;
                        background-color: #99A9BF;
                        text-align: left;
                    }
                    .module-content {
                        text-align: left;
                        font-size: 12px;
                        margin: 11px 11px 0 11px;
                    }
                }
                .news-list {
                    padding: 11px;
                    li {
                        padding-bottom: 5px;
                        border-bottom: 1px solid #D3DCE6;
                    }
                    .news-item {
                        display: block;
                        color: black;
                        text-decoration: none;
                        text-align: left;
                        margin-top: 20px;
                    }
                    .btn-group {
                        display: block;
                        margin-top: 5px;
                    }
                }
            }
        }
    }
    .el-form-item__label {
        font-weight: bold;
    }
    ol,
    ul {
        list-style: none;
    }
    .el-carousel__indicator {
        .el-carousel__button {
            width: 10px;
            height: 10px;
            border-radius: 50%;
        }
    }
    .el-form-item-btn-group {
        .el-form-item__content {
            margin-left: 0!important;
        }
    }
}
</style>



// WEBPACK FOOTER //
// Edit.vue?8a65abd8